import styled from "styled-components";
import {JackpotToastTitleAnimatedDefaultBox} from "./jackpot-toast-title-animated.default.box";

export const JackpotToastTitleAnimatedCasino777Box = styled(JackpotToastTitleAnimatedDefaultBox)`
    ${props => props.theme.font.presets.body};
    font-size: 2rem;
`;
